<template>
  <div>
    <textarea
      :id="props.field.name"
      v-model="selectedValue"
      v-focus
      class="flex h-full min-h-[30vh] w-full shrink grow basis-0 flex-col items-start justify-start gap-2.5
        self-stretch rounded-lg border border-gray-200 bg-white px-2 py-[22px] shadow sm:w-[400px] sm:px-5"
      :class="`focus:outline-none focus:ring-0 focus:border-${themeColor}-500 focus:border-2`"
      placeholder="Geben Sie hier Ihre Antwort ein...."
      :type="props.field.type"
      :name="props.field.name"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script setup>
  import { useFormField } from '@/composables/useFormField'
  import { useThemeColor } from '@/composables/useThemeColor'
  import { computed } from 'vue'

  defineEmits(['update:modelValue'])

  const props = defineProps({
    field: {
      type: Object,
      default: null
    },
    modelValue: {
      type: String,
      default: ''
    }
  })

  const { selectedValue } = useFormField(props)
  const themeColor = computed(() => useThemeColor().value)
</script>
